type Item = { is_default: boolean };
type OrderedItem = { order: number };

export const getDefaultItem = <T extends Item>(items: T[] = []): T | null => {
  return items.find((item) => item.is_default) || items[0] || null;
};

export const getFirstItemByOrder = <T extends OrderedItem>(items: T[] = []): T => {
  return items.find((item) => item.order === 0) || items[0];
};
